export const useAbsoluteBackground = (
    props?: {
        zIndex?: number;
        isNotBottom?: boolean;
        isNotTop?: boolean;
        isNotLeft?: boolean;
        isNotRight?: boolean;
    },
    styles?: React.CSSProperties
) => {
    const internalStyles = Object.assign({}, styles || ({} as React.CSSProperties));
    internalStyles.position = `absolute`;
    internalStyles.userSelect = "none";
    internalStyles.zIndex = props?.zIndex || 0;

    if (!props?.isNotTop) {
        internalStyles.top = 0;
    }
    if (!props?.isNotBottom) {
        internalStyles.bottom = 0;
    }
    if (!props?.isNotLeft) {
        internalStyles.left = 0;
    }
    if (!props?.isNotRight) {
        internalStyles.right = 0;
    }

    return internalStyles;
};